'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _itemFacets = require('./remote/itemFacets');

var ItemFacets = {
    fetchItemFacets: _itemFacets.ItemFacetsRemote.fetchItemFacets
};

exports.default = ItemFacets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/itemFacets.js
// module id = ZbCA
// module chunks = 60